__turbopack_context__.v({
  "container": "top-app-bar-module-scss-module__VYBB5a__container",
  "fix": "top-app-bar-module-scss-module__VYBB5a__fix",
  "title": "top-app-bar-module-scss-module__VYBB5a__title",
});
